import { useEffect, useRef } from "react";
import { isMobile, scroll2Top } from "../../utils/utils";
import RERecapRetirementBloc from "../../blocs/retirement/info-perso/RERecapRetirementBloc";



export default function RERecapRetirementPage() {
    
  const pageGapRef = useRef<null | HTMLDivElement>(null);
  useEffect(() => {
    if (isMobile()) {
      pageGapRef.current?.scrollIntoView() 
    } else {
      scroll2Top();
    }
  }, []);

    return (
    
      <div className="entreprise-container">
        <h1 ref={pageGapRef} className="title mb-sm ml-lg-desktop">Récapitulatif</h1>
        <RERecapRetirementBloc />
      </div>
    
    )

}